<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Acknowledgements</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<div id="acknowledgements">
<p class="chap-ttl"><a id="pviii"></a><a href="#/Table_of_contents">Acknowledgements</a></p>
<p class="chap-bm-first">I would like to thank seven of my many excellent Regent College teaching assistants over the years for their help in this project. James Smoker and Stacey Van Dyk researched the Bibliography as the project got going; Margie McKerron did a whole lot of work chasing down references, reading the manuscript and bringing the project to a conclusion; Henna Lehtonen and Timothy Tse took time out from other duties to help her; and Jacob Taxis and Amy Anderson generated the Indexes. I would also like to thank the students in my Genesis classes in 2012 and 2013, who helped me to sharpen my thinking about reading the text. I have always found my teaching to benefit my research, and vice versa, and I am glad to have worked in educational institutions where both have been valued – not the least of which has been Regent College, my academic home for the last 18 years. Finally, I am grateful to Philip Law and SPCK for the opportunity to write this particular book. I hope that many people will find it helpful.</p>
<p class="chap-bm-right"><span class="epub-italic-normal-normal">Iain Provan</span><br/> <span class="epub-italic-normal-normal">Vancouver, Canada</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?7085b23e